// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bkf-action-button[data-v-7ee5b2ac]{margin:0}", "",{"version":3,"sources":["webpack://./src/components/actions/Action/Action.styl"],"names":[],"mappings":"AAAA,oCACE,QAAQ","sourcesContent":[".bkf-action-button\n  margin: 0"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
